import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as jsonPatch from 'fast-json-patch';
import { Observable } from 'rxjs';

/**
 * Este servicio sirve para poder comparar distintos archivos tipo JSON
 */
import * as ɵngcc0 from '@angular/core';
class JsonPatchService {
    /**
     * Método que se utiliza para comparar dos archivos e indicar qué operaciones se han realizado.
     * @param source Archivo original
     * @param target Archivo objetivo
     * @returns Devuelve un Array con las distintas operaciones que se han realizado, indicando sus tipos, paths y valores extras (si tiene)
     */
    static compare(source, target) {
        const result = [];
        if (source && target) {
            const operations = jsonPatch.compare(source, target);
            operations.forEach((operation) => {
                let jsonPatchOperation = {
                    op: operation.op,
                    path: operation.path
                };
                if (operation.op === "add" || operation.op === "replace" || operation.op === "test" || operation.op === "_get") {
                    jsonPatchOperation.value = operation.value;
                }
                else if (operation.op === "move" || operation.op === "copy") {
                    jsonPatchOperation.from = operation.from;
                }
                result.push(jsonPatchOperation);
            });
        }
        return result;
    }
    /**
     * Método que se utiliza para comparar dos archivos, teniendo únicamente en cuenta las operaciones que sean de tipo "replace"
     * @param source Archivo original
     * @param target Archivo objetivo
     * @returns Devuelve un Array con las operaciones de tipo Replace
     */
    static compareReplace(source, target) {
        const result = [];
        if (source && target) {
            const operations = jsonPatch.compare(source, target);
            operations.forEach((operation) => {
                const replaceOperation = operation;
                if (replaceOperation) {
                    let path = replaceOperation.path.replace(new RegExp("/", "g"), '.');
                    path = path.replace('.', '');
                    let jsonPatchReplaceOperation = {
                        op: replaceOperation.op,
                        path: path,
                        value: replaceOperation.value
                    };
                    result.push(jsonPatchReplaceOperation);
                }
            });
        }
        return result;
    }
    /**
     * Método que se utiliza para comparar si dos archivos son iguales
     * @param firstFile Primer archivo
     * @param target Segundo archivo
     * @returns Devuelve un booleando indicando si son iguales o no
     */
    static areEqual(firstFile, secondFile) {
        return (firstFile && secondFile) ? jsonPatch._areEquals(firstFile, secondFile) : false;
    }
}
JsonPatchService.ɵfac = function JsonPatchService_Factory(t) { return new (t || JsonPatchService)(); };
JsonPatchService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: JsonPatchService, factory: JsonPatchService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(JsonPatchService, [{
        type: Injectable
    }], null, null); })();

class UtilsModule {
}
UtilsModule.ɵfac = function UtilsModule_Factory(t) { return new (t || UtilsModule)(); };
UtilsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UtilsModule });
UtilsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [JsonPatchService] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UtilsModule, [{
        type: NgModule,
        args: [{
                providers: [JsonPatchService]
            }]
    }], null, null); })();

/**
 * Resize observer
 *
 * Esta clase contiene el método resizeObservable, el cual devuelve un Observable que contiene un ResizeObserver,
 * que sirve para detectar cambios en el resize de elementos.
 */
// @dynamic
class ResizeObservable {
    /**
     * Devuelve un Observable que contiene un ResizeObserver, que sirve para detectar cambios en el resize de elementos
     *
     * @param elementToObserve Elemento a observar. Si nos suscribimos al observable con dicho elemento y éste detecta un resize sobre si mismo, el observable lo detectará.
     * @returns Observable<any>
     *
     */
    static resizeObservable(elementToObserve) {
        return new Observable(subscriber => {
            let resizeObserver = new ResizeObserver(resizeObserverEntry => {
                subscriber.next(resizeObserverEntry);
            });
            resizeObserver.observe(elementToObserve);
            return function unsubscribe() {
                resizeObserver.unobserve(elementToObserve);
            };
        });
    }
}

class CdaService {
    constructor() {
        this.base31String = '0123456789BCDFGHJKLMNPQRSTVWXYZ';
    }
    calculateCda(idCda) {
        if (!idCda || idCda.length !== 5 || idCda === '00000') {
            return '';
        }
        const base31Length = this.base31String.length;
        let valor = 0;
        try {
            Array.from(idCda).forEach((item) => {
                const p = this.base31String.indexOf(item);
                if (p === -1) {
                    throw {};
                }
                valor = valor * base31Length + p;
            });
        }
        catch (e) {
            return '';
        }
        const result = valor + '';
        return result;
    }
}
CdaService.ɵfac = function CdaService_Factory(t) { return new (t || CdaService)(); };
/** @nocollapse */ CdaService.ɵprov = i0.ɵɵdefineInjectable({ factory: function CdaService_Factory() { return new CdaService(); }, token: CdaService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CdaService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CdaService, JsonPatchService, ResizeObservable, UtilsModule };

